import React from 'react';
import { HelmetProvider, Helmet } from 'react-helmet-async'; 
import TopBanner from '../../components/TopBanner';
import BlogSideBar from '../../components/BlogSideBar';
// import { ScrollToContent } from './ScrollToContent';

// const LazyBlogSideBar = React.lazy(() => import('../../components/BlogSideBar')); // Lazy load BlogSideBar

const BlogItem = (props) => {
  const { blog } = props || {};
  // if (!blog) {
  //   return <div>Loading...</div>;
  // }

  const server_url = process.env.REACT_APP_SERVER;
  const truncatedDescription = blog.description.length > 147
    ? blog.description.substring(0, 147) + '...'
    : blog.description;

  const truncatedTitle = blog.title.length > 45
    ? blog.title.substring(0, 35) + '...'
    : blog.title;

  const blogStructuredData = {
    "@context": "https://schema.org",
    "@type": "Article",
    headline: blog.title,
    description: truncatedDescription,
    image: `${server_url}${blog.imageUrlPath}`,
    datePublished: blog.displaydate.toUTCString(),
    author: {
      "@type": "Person",
      name: blog.author,
      url: blog.authorContactUrl,
    },
    publisher: {
      "@type": "Organization",
      name: "Lurantech",
      logo: {
        "@type": "ImageObject",
        url: `${server_url}/images/logo.png`
      }
    }
  };

  const blogUrl = server_url+"/blog/" + blog.title.replace(/\s+/g, '-').replace(/[^a-zA-Z0-9-]/g, '').toLowerCase();
  const facebookShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(blogUrl)}`;
  const linkedinShareUrl = `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(blogUrl)}`;
  const twitterShareUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(blogUrl)}`;

  return (
    <HelmetProvider>
      <div>
        <Helmet>
          <meta property="og:title" content={truncatedTitle} />
          <meta property="og:description" content={truncatedDescription} />
          <meta property="og:image" content={`${server_url+blog.imageUrlPath}`} />
          <meta property="og:type" content="article" />
          <meta property="og:image:type" content="image/jpeg" />
          <meta property="og:image:width" content="1200" />
          <meta property="og:image:height" content="675" />
          
          <meta property="og:site_name" content="Lurantech pvt ltd" />
          <meta property="og:locale" content="en" />
          
          <meta property="article:published_time" content={blog.displaydate.toUTCString()} />
          <meta property="article:author" content={blog.author} />
          <meta property="article:section" content="world" />
          <meta name="geo.position" content="22.3026;73.1812" />
          <meta name="geo.placename" content="4th Floor - Office 1, 7, Sky Complex, Laxmipura, Vadodara, Gujarat 390021" />
          <meta name="geo.region" content="IN-GJ" />
          <meta property="og:latitude" content="22.3026" />
          <meta property="og:longitude" content="73.1812" />
          <meta property="og:location" content="4th Floor - Office 1, 7, Sky Complex, Laxmipura, Vadodara, Gujarat 390021" />


          <meta name="twitter:title" content={truncatedTitle} />
          <meta name="twitter:description" content={truncatedDescription} />
          <meta name="twitter:image" content={`${server_url+blog.imageUrlPath}`} />
          <meta property="twitter:image:type" content="image/jpeg" />
          <meta property="twitter:image:width" content="1200" />
          <meta property="twitter:image:height" content="675" />

          <meta name="robots" content="index, follow" />
          <meta name="description" content={truncatedDescription} />
          <meta name="keywords" content={blog.keywords.join(', ')+", liferay blogs, liferay cms, liferay india"} />
          <meta name="author" content={blog.author} />
          
          <link rel="canonical" href={`${server_url}/blog/${blog.title.replace(/\s+/g, '-').toLowerCase()}`} />
          <link rel="preload" href={`${server_url+blog.imageUrlPath}`} as="image" /> 
          <title>{truncatedTitle + ' | Blog | Lurantech'}</title>
        </Helmet>

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(blogStructuredData),
          }}
        />

        <TopBanner title={blog.title} bgimage="/images/blogs/blog.gif" />

        <div className="blog-container">
          <div className="row g-0">
            <div className="col-12 col-sm-8 col-md-8 col-lg-8 col-xl-8">
              <div className="s-blog-container">
                <div className="blog-img">
                  <img src={blog.imageUrlPath} alt={blog.title || 'Blog Image'} loading="lazy" width={100} />
                </div>
                <div className="blog-info">
                  <img src="/images/blogs/author-icon.svg" alt="lurantech-author" />
                  <div className='author-text'>{blog.author}</div>
                  <img src="/images/blogs/clock-icon.svg" alt="blog-display-date" />
                  <div className='clock-text'>{blog.displaydate.toDateString()}</div>
                </div>
                <div className="blog-title">
                  {blog.title}
                </div>
                <p className="blog-description-">
                  {blog.description}
                </p>
                {/* <div className="blog-button">
                  <a href="#blogContent" onClick={(e) => ScrollToContent(e, '#blogContent')}> Read More &#x2197; </a>
                </div> */}
                <div className="blog-content" id="blogContent">
                  {blog.content}
                </div>
                <p><strong>For any query or more information related our blog don't hesitate to <a href="/contact-us" >Reach us out.</a></strong></p>
                <div className="share-container">
                  <span className="share-text">Share :</span> 
                  <a target="_blank" rel="noreferrer" href={linkedinShareUrl}><img src="/images/footer/linkedin-logo.svg" alt="lurantech-share-blog-linkedin" width={48} height={48}/></a>
                  <a target="_blank" rel="noreferrer" href={twitterShareUrl}><img src="/images/footer/x-logo.svg" alt="lurantech-share-blog-twitter" width={48} height={48} /></a> 
                  <a target="_blank" rel="noreferrer" href={facebookShareUrl}><img src="/images/footer/fb-logo.svg" alt="lurantech-share-blog-facebook" width={48} height={48} /></a>
                </div>
              </div>
            </div>

            <div className="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
              {/* <Suspense fallback={<div>Loading...</div>}>
                <LazyBlogSideBar blog={blog} />
              </Suspense> */}

              <BlogSideBar blog={blog} />
            </div>
          </div>
        </div>
      </div>
    </HelmetProvider>
  );
};

export default BlogItem;
